import requestIdPlugin from '@daangn/plantae-plugin-request-id'

const plantaeRequestIdPlugin = () => requestIdPlugin()

export default plantaeRequestIdPlugin
